import { render } from "./PlanImportBuyTemplate.vue?vue&type=template&id=4998549b"
import script from "./PlanImportBuyTemplate.vue?vue&type=script&lang=js"
export * from "./PlanImportBuyTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__